<!-- Change Date Modal -->
<p-dialog [(visible)]="visible" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '340px'}" styleClass="no-header-modal overflow-visible">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <!-- Header -->
        <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
            <h2 class="mb-0 text-base font-bold">{{'SUBSCRIPTIONS.MEMBERSHIP_SESSIONS.LABLE_EDIT' | translate}}</h2>
            <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup(false)"></div>
        </div>
        <!-- Header -->

        <form [formGroup]="EditMembershipSessionsForm" (ngSubmit)="UpdateMembershipSessions()">
            <!-- Content -->
            <div class="surface-100 p-3">
                <div class="flex align-items-center">
                    <div class="w-9">
                        <div class="mb-3">
                            <label class="font-medium text-700 text-xs mb-2 block uppercase" *ngIf="membershipId > 0 ">
                                {{ 'SUBSCRIPTIONS.MEMBERSHIP_SESSIONS.AVAILABLE_SESSION' | translate }}
                            </label>
                            <p-inputNumber formControlName="available_sessions" [showIcon]="true" inputStyleClass="text-sm" styleClass="w-full text-sm"> </p-inputNumber>
                        </div>
                        <div>
                            <label class="font-medium text-700 text-xs mb-2 block uppercase" *ngIf="membershipId > 0 ">
                                {{ 'SUBSCRIPTIONS.MEMBERSHIP_SESSIONS.TOTAL_SESSION' | translate }}
                            </label>
                            <p-inputNumber formControlName="total_sessions" [showIcon]="true" inputStyleClass="text-sm" styleClass="w-full text-sm"> </p-inputNumber>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Content -->

            <!-- Content -->
            <div class="p-3">
                <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SUBSCRIPTIONS.MEMBERSHIP_SESSIONS.CHANGE_REASON' | translate}}</label>
                <textarea pInputTextarea class="w-full h-4rem text-sm" formControlName="comment" [placeholder]="'SUBSCRIPTIONS.MEMBERSHIP_SESSIONS.REASON_PALCEHOLDER' | translate"></textarea>
            </div>
            <!-- Content -->

            <!-- Footer -->
            <div class="p-3 flex justify-content-between align-items-center border-top-1 border-300">
                <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" class="p-button-text text-sm" (click)="closePopup(false)"></button>
                <button pButton pRipple type="submit" [loading]="isFormSubmitting" [label]="'SUBSCRIPTIONS.MEMBERSHIP_SESSIONS.BTN_CHANGE_SESSIONS' | translate" class="text-sm"></button>
            </div>
            <!-- Footer -->
        </form>
    </ng-template>
</p-dialog>
<!-- Change Date Modal -->


